"use client";
import { ActiveEntitlements } from "@jurni/schemas";
import { createContext, ReactNode, useContext } from "react";

const EntitlementsContext = createContext<ActiveEntitlements | undefined>(
  undefined,
);

export const EntitlementsProvider = ({
  children,
  entitlements,
}: {
  children: ReactNode;
  entitlements?: ActiveEntitlements;
}) => {
  return (
    <EntitlementsContext.Provider value={entitlements}>
      {children}
    </EntitlementsContext.Provider>
  );
};

export const useEntitlements = () => {
  const context = useContext(EntitlementsContext);

  if (context === undefined) {
    throw new Error(
      "useEntitlements must be used within a valid EntitlementsProvider",
    );
  }
  return context;
};

// For UI that can be left out when the entitlements request failed, instead of
// failing the whole page the way useEntitlements does.
export const useHasEntitlements = () =>
  useContext(EntitlementsContext) !== undefined;
